// extracted by mini-css-extract-plugin
export default {"main_page":"RenaultLogan_main_page__9PsFK","car_image":"RenaultLogan_car_image__6x2fn"};